import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button, Container, Row } from 'reactstrap';
import moment from 'moment';

// Services
import { getSessionCookie } from '../../../../services/session';

// Components
import Header from '../../../../components/Headers/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

//Constants
import { relatorioStyles } from '../../../../constants/relatorioStyles';


function RelatorioQualidadeAnalitico({ handleReturn, cabecalho, relatorio }) {
    const session = getSessionCookie();

    const refImprimir = useRef();

    // Função acionada assim que o botão de imprimir é clicado
    const handlePrint = useReactToPrint({
        content: () => refImprimir.current,
        copyStyles: true,
        documentTitle: "Relatório Atendimento Analitico",
        pageStyle: relatorioStyles
    });

    return (
        <>
            <Header />
            <Row>
                <Container className="mt--9" fluid>
                    <div className='d-flex justify-content-between align-items-center mb-1'>
                        <Button color="secondary" type="button" onClick={() => handleReturn()}>
                            Voltar
                        </Button>
                        <Button color="danger" type="button" onClick={handlePrint}>
                            <FontAwesomeIcon icon={faPrint} /> Imprimir
                        </Button>
                    </div>
                    <div className="card shadow">
                        <div className='card-body print-padding print' ref={refImprimir}>
                            <div className='row header'>
                                <div className='col-sm-12 col-lg-12 text-center print-image' style={{ display: "none" }}>
                                    <img
                                        src={require("assets/img/brand/logo.png")}
                                        alt="imagem do sistema"
                                        width={150}
                                    />
                                </div>
                                <div className='col-sm-12 col-lg-12'>
                                    <h2>Relatório Qualidade Analítico</h2>
                                </div>
                                <div className='col-sm-12 col-lg-12'>
                                    <span className='font-weight-bold'>Modalidade de Serviço: </span> <span>{cabecalho?.modalidade}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Data Início:</span> <span>{cabecalho?.dataInicio && moment(cabecalho?.dataInicio).format("DD/MM/YYYY")}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Data Fim:</span> <span>{cabecalho?.dataFim && moment(cabecalho?.dataFim).format("DD/MM/YYYY")}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Divisão Administrativa:</span> <span>{cabecalho?.divisaoAdministrativa}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Plano de Trabalho:</span> <span>{cabecalho?.planoTrabalho}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Status Avaliação:</span> <span>{cabecalho?.statusAvaliacao}</span>
                                </div>
                            </div>
                            <div className='row'>
                                <div className={"mt-3 col-sm-12 col-lg-12 "}>
                                    <div className='table-responsive table-padding'>
                                        <table className='table-bordered tabela-relatorio w-100' >
                                            <thead style={{ background: "#BEBEBE" }}>
                                                <tr>
                                                    <th>OPERADOR / RECURSO</th>
                                                    <th>INÍCIO / FIM <br /> DA EXECUÇÂO</th>
                                                    <th>PROGRAMADOS / AVULSOS</th>
                                                    <th>EXECUÇÕES TOTAIS /  EXECUÇÕES PARCIAIS</th>
                                                    <th>JUSTIFICATIVA(S) DE <br /> EXECUÇÃO PARCIAL</th>
                                                    <th>NÃO EXECUÇÕES</th>
                                                    <th>JUSTIFICATIVA(S) DA <br /> NÃO EXECUÇÃO</th>
                                                    <th>ÍNDICE DE QUALIDADE</th>
                                                    <th>USUÁRIO AVALIAÇÂO</th>
                                                    <th>STATUS AVALIAÇÂO</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {relatorio?.map((value, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr>
                                                            <td className="text-center">{value.operador?.toUpperCase()}</td>
                                                            <td className="text-center">{value.dataHoraExecucaoInicio}</td>
                                                            <td className="text-center">{value.programadas}</td>
                                                            <td className="text-center">{value.execucaoTotal}</td>
                                                            <td className="text-center" rowSpan={2}>{value.justificativaParcial}</td>
                                                            <td className="text-center" rowSpan={2}>{value.naoExecucao}</td>
                                                            <td className="text-center" rowSpan={2}>{value.justificativaNaoExecucao}</td>
                                                            <td className="text-center">{value.porcentagemIndiceQualidade}</td>
                                                            <td className="text-center" rowSpan={2}>{value.usuarioAvaliacao}</td>
                                                            <td className="text-center" rowSpan={2}>{value.statusAvaliacao}</td>
                                                        </tr>

                                                        <tr>
                                                            <td className="text-center">{value.veiculo?.toUpperCase()}</td>
                                                            <td className="text-center">{value.dataHoraExecucaoFim}</td>
                                                            <td className="text-center">{value.avulsa}</td>
                                                            <td className="text-center">{value.execucaoParcial}</td>
                                                            <td className="text-center">{value.condicao}</td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='print-footer w-100 mt-2' style={{ display: "none" }}>
                                    <p className='font-weight-bold text-right'>Gerado em {moment().format("DD/MM/YYYY HH:mm")}, Por {session?.nome}.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </Row>
        </>
    );
}

export default RelatorioQualidadeAnalitico;
